import React from "react";
import styled from "styled-components";
import { getLocale } from "react-i18nify";

import { Stack, Typography } from "@mui/material";

import font from "src/styles/font";
import device from "src/styles/device";
import { checkNotEmpty } from "src/common";
import { Primary, Black, DarkGrey } from "src/styles/color";

import LabelSection from "src/components/core/LabelSection";

const GridKeywords = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 8px;
  flex: 1;

  @media ${device.laptop} {
    grid-auto-flow: column;
    grid-template-rows: repeat(5, 1fr);
    grid-template-columns: repeat(2, 1fr);
  }
`;

const GridItem = styled.div`
  display: flex;
  /* align-items: center; */
  gap: 8px;
`;

const PopularKeywordsList = ({ data = [], selectedTimeRangeData }) => {
  const getStyleByIndex = (index, type) => {
    switch (index) {
      case 0:
        return {
          fontWeight: 600,
          color:
            type === "text" ? Black : type === "times" ? DarkGrey : Primary,
        };
      case 1:
        return {
          fontWeight: 600,
          color:
            type === "text" ? Black : type === "times" ? DarkGrey : Primary,
        };
      case 2:
        return {
          fontWeight: 600,
          color:
            type === "text" ? Black : type === "times" ? DarkGrey : Primary,
        };
      default:
        return { color: type === "times" ? DarkGrey : Black };
    }
  };
  return (
    <LabelSection
      title={getLocale() === "th" ? "คำค้นยอดนิยม" : "Popular Keywords"}
      description={
        <Typography
          variant="body2"
          sx={{ ml: 2.5, "&.MuiTypography-root": { fontSize: font.size.xs } }}
        >
          {getLocale() === "th"
            ? `${selectedTimeRangeData?.label?.th}`
            : `${selectedTimeRangeData?.label?.en}`}
        </Typography>
      }
      style={{ marginBottom: 0, height: "100%" }}
      titleStyle={{ fontSize: font.size.lg, fontWeight: 600 }}
      headerStyle={{ marginBottom: 16 }}
    >
      {checkNotEmpty(data) ? (
        <GridKeywords>
          {data.map((item, idx) => (
            <GridItem key={idx}>
              <Typography
                variant="body1"
                sx={{ mt: 0.1, minWidth: 24, ...getStyleByIndex(idx, "index") }}
              >
                {(idx + 1).toString().padStart(2, "0")}
              </Typography>
              <Stack height={"100%"}>
                <Typography variant="body1" sx={getStyleByIndex(idx, "text")}>
                  {item.searchTerm}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    ...getStyleByIndex(idx, "times"),
                    "&.MuiTypography-root": {
                      fontSize: font.size.xs,
                      fontWeight: 400,
                      lineHeight: 1.2,
                    },
                  }}
                >
                  {item.eventCount} {getLocale() === "th" ? "ครั้ง" : "times"}
                </Typography>
              </Stack>
            </GridItem>
          ))}
        </GridKeywords>
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          gap={2}
          height={"100%"}
          minHeight={{ xs: 200, md: 300 }}
        >
          <Typography variant="body2">
            {getLocale() === "th" ? "ไม่มีข้อมูล" : "No data available"}
          </Typography>
        </Stack>
      )}
    </LabelSection>
  );
};

export default PopularKeywordsList;
